<template>
    <ToolButton :Editor="Editor" KnownIcon="ListOrdered" 
    @ToolClick="Editor.chain().focus().toggleOrderedList().run()">
    :class="{ 'toggled': Editor.isActive('orderedList') }"
    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>